module.exports = __webpack_public_path__ + "static/media/img11.b07b9d6a.JPG";